import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';
import { flex, textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        height: '100%',
        [theme.down('mobile')]: {
            height: 'auto',
        },
        padding: `${theme.spacing(4)}px ${theme.spacing(8)}px ${theme.spacing(8)}px`,
        [theme.down('desktop')]: {
            padding: `${theme.spacing(3)}px ${theme.spacing(5)}px ${theme.spacing(5)}px`,
        },
        [theme.down('tablet')]: {
            padding: theme.spacing(4),
        },
    },

    body: {
        display: 'flex',
        padding: `${theme.spacing(4)} ${0} ${theme.spacing(4)} ${theme.spacing(11.5)}`,
    },

    header: {
        color: theme.colors.grey_text,
        fontSize: 16,
        fontFamily: theme.font.secondary,
        lineHeight: 1.25,
        paddingBottom: 10,
    },

    emailWrapper: {
        width: 443,
    },

    groupsWrapper: {
        width: 304,
    },

    text: {
        color: theme.colors.black,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: theme.font.primary,
    },

    expandIcon: {
        transformOrigin: 'center',
        transition: 'transform .2s ease',
        transform: 'rotate(90deg)',

        '&$expanded': {
            transform: 'rotate(-90deg)',
        },
    },

    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        height: 24,
        width: 24,
        ...flex('row', 'center', 'center'),

        '&:disabled': {
            opacity: 0.3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },

    buttonInvite: {
        width: 26,
        height: 26,
    },

    userWrapper: {
        ...flex('row', 'flex-start', 'center'),
    },

    userAvatar: {
        display: 'inline-flex',
        marginRight: theme.spacing(3),
        [theme.down('desktop')]: {
            display: 'none',
        },
    },

    tableActionsContainer:{
        minHeight: 72,
        alignContent: 'center',
        marginBottom: theme.spacing(2),
    },
    tableActions: {
        ...flex('row', 'space-between', 'center'),
        padding: `0 ${theme.spacing(4)}`,
        gap: theme.spacing(1.5),
        flexWrap: 'nowrap',
        [theme.down('tablet')]: {
            padding: 0,
            flexWrap: 'wrap',
        },
    },
    filters: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: theme.spacing(1.5),
        flex: '0 1 auto',
        [theme.down('tablet')]: {
            width: '100%',
        },
    },
    summaryPanel: {
        display: 'flex',
        flex: '1 1 32rem',
        minWidth: 0,
        maxWidth: '55rem',
        marginBottom: 0,
        [theme.down('tablet')]: {
            width: '100%',
            minWidth: 0,
        },
    },

    buttonsWrapper:{
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        justifyContent: 'flex-end',
        flexShrink: 0,
        alignItems: 'center',
        [theme.down('tablet')]: {
            width: '100%',
            justifyContent: 'flex-start',
        },
    },

    invite: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    },
    h4: {
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        color: theme.colors.black,
    },
    addIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
        marginLeft: theme.spacing(3),
    },

    filterIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
    },

    searchWrapper: {
        width: 240,
        marginRight: theme.spacing(2),
        [theme.down('tablet')]: {
            width: 'min(100%, 360px)',
            marginRight: 0,
        },
    },

    moreItemsPresent: {
        // color: theme.colors.blue_link,
        // marginLeft: theme.spacing(2),
        // fontFamily: theme.font.secondary,
    },

    noInfo: {
        color: theme.colors.grey_text,
        ...textOverflowDots(),
        display: 'inherit',
    },

    userStatus: {
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        borderRadius: theme.radius,
        color: theme.colors.violet_primary,
        backgroundColor: `${color(theme.colors.violet_primary).fade(0.92)}`,

        '&$notActive': {
            color: theme.colors.grey_text,
            backgroundColor: `${color(theme.colors.grey_lighter).fade(0.35)}`,
        },
    },

    capitalized: {
        textTransform: 'capitalize',
    },

    exportButton: {
        marginLeft: 10,
        [theme.down('tablet')]: {
            marginLeft: 0,
        },
    },

    importButton: {
        marginLeft: 10,
        [theme.down('tablet')]: {
            marginLeft: 0,
        },
    },

    ellipsis: {
        ...textOverflowDots(),
    },
}));
